export default "https://cdn-static-staging.gokick.com/assets/ec0de4ab37568b9a2e84c5fbf7dadc9a5c7c6fae/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";